import store from "@/store";

export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        $rbac() {
          return {
            can: code => {
              if (!store.state.rbac.rbacEnabled) return true;
              const perms = store.state.rbac.myPermissions;
              if (!perms || !perms.length) return false;
              return perms.includes(code);
            },
          };
        },
      },
    });
  },
};
